import { AnswerCommand } from 'core/commands/elements/answers/answer.abstract.command';
import { tactileoAnswersDTOTypes } from 'utils/activityItem.util';

export class AudioQuestionAnswerCommand extends AnswerCommand {
  constructor(audioQuestion) {
    super(tactileoAnswersDTOTypes.AUDIO_QUESTION, audioQuestion);
    this.audio_file_url = audioQuestion.audioFileUrl;
  }
}
